import { Pipe, PipeTransform } from '@angular/core';
import { Product } from 'src/app/shop';
import { ProductPreview } from '../models';

@Pipe({ name: 'filterProductsNotFound' })
export class FilterProductsNotFoundPipe implements PipeTransform {
  // Filters products that have been added in our CMS but have been removed in Shopify
  transform(value: ProductPreview[], ...args: any[]): ProductPreview[] {
    const loaded = args[0];
    const productsFromShopify: Product[] = args[1];

    if (!loaded) {
      return value;
    }

    if (!productsFromShopify?.length) {
      return [];
    }

    return value.filter(a => productsFromShopify.filter(b => b.id.replace('gid://shopify/Product/', '') === a.productId).length);
  }
}
